import React from 'react';
import { useTranslation } from 'react-i18next';
// --- INICIO DE LA CORRECCIÓN ---
// 1. Importar la lista de monedas centralizada.
import { supportedCurrencies } from '../../config/currencies.config.js';
// --- FIN DE LA CORRECCIÓN ---

const PremiumContentOptionsForm = ({ price, onPriceChange, disabled }) => {
  const { t } = useTranslation();

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    const finalValue = name === 'amount' ? parseFloat(value) || 0 : value;
    const newPrice = { ...price, [name]: finalValue };
    if (onPriceChange) {
      onPriceChange(newPrice);
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div>
        <label
          htmlFor="price-amount"
          className="block text-sm font-semibold text-neutral-700 dark:text-neutral-200 mb-1"
        >
          {t('common.price_label')}
        </label>
        <div className="flex items-center gap-2">
          {/* --- INICIO DE LA CORRECCIÓN --- */}
          <input
            type="number"
            id="price-amount"
            name="amount"
            value={price.amount}
            onChange={handlePriceChange}
            disabled={disabled}
            className="form-input"
            min="0"
            step="1" // 2. Se asegura que los incrementos sean de 1 en 1.
            onKeyDown={(e) => {
              // 3. Previene la escritura de comas y puntos.
              if (['.', ','].includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
          <select
            id="price-currency"
            name="currency"
            value={price.currency}
            onChange={handlePriceChange}
            disabled={disabled}
            className="form-input"
          >
            {/* 4. Se rellena el selector dinámicamente. */}
            {supportedCurrencies.map((currency) => (
              <option key={currency.code} value={currency.code}>
                {currency.code}
              </option>
            ))}
          </select>
          {/* --- FIN DE LA CORRECCIÓN --- */}
        </div>
      </div>
    </div>
  );
};

export default PremiumContentOptionsForm;
